const MEDIA = window.GK_MEDIA || {};
Object.keys(MEDIA).forEach(k => { if (!MEDIA[k]) MEDIA[k] = MEDIA.white; });

/* ══ 1. PRODUCT CONFIG ══ */
const CONFIG = {
  currency: "$",
  sets: [
    { option:"White", qty:"1PC", name:"Single", sub:"White · one unit", price:114.99, compare:0, tag:"",
      shots:[{k:"white"}],
      incl:"One massager in white, Type-C cable, manual and retail box." },
    { option:"White", qty:"2PCS", name:"Pair", sub:"White · two units", price:114.99, compare:0, tag:"",
      shots:[{k:"white",c:"Massager ×2",x:"×2"}],
      incl:"Two massagers in white, Type-C cables, manuals and retail boxes." },
    { option:"Wood Color", qty:"1PC", name:"Single", sub:"Wood grain", price:114.99, compare:0, tag:"",
      shots:[{k:"wood"}],
      incl:"One massager in wood grain, Type-C cable, manual and retail box." },
    { option:"White S set", qty:"1PC", name:"Set · S", sub:"1 unit + sleeves", price:139.99, compare:0, tag:"",
      shots:[{k:"white",c:"Massager ×1"},{k:"sleeve",c:"Size S sleeve ×2"}],
      incl:"One massager, two size S compression sleeves, Type-C cable, manual and retail box." },
    { option:"White M set", qty:"1PC", name:"Set · M", sub:"1 unit + sleeves", price:139.99, compare:0, tag:"Most picked",
      shots:[{k:"white",c:"Massager ×1"},{k:"sleeve",c:"Size M sleeve ×2"}],
      incl:"One massager, two size M compression sleeves, Type-C cable, manual and retail box." },
    { option:"White L set", qty:"1PC", name:"Set · L", sub:"1 unit + sleeves", price:139.99, compare:0, tag:"",
      shots:[{k:"white",c:"Massager ×1"},{k:"sleeve",c:"Size L sleeve ×2"}],
      incl:"One massager, two size L compression sleeves, Type-C cable, manual and retail box." },
    { option:"White S set1", qty:"1PC", name:"Twin · S", sub:"2 units + sleeves", price:219.99, compare:0, tag:"",
      shots:[{k:"white",c:"Massager ×2",x:"×2"},{k:"sleeve",c:"Size S sleeve ×2"}],
      incl:"Two massagers, two size S compression sleeves, Type-C cables, manuals and boxes." },
    { option:"White M set1", qty:"1PC", name:"Twin · M", sub:"2 units + sleeves", price:219.99, compare:0, tag:"",
      shots:[{k:"white",c:"Massager ×2",x:"×2"},{k:"sleeve",c:"Size M sleeve ×2"}],
      incl:"Two massagers, two size M compression sleeves, Type-C cables, manuals and boxes." },
    { option:"White L set1", qty:"1PC", name:"Twin · L", sub:"2 units + sleeves", price:219.99, compare:0, tag:"Best value",
      shots:[{k:"white",c:"Massager ×2",x:"×2"},{k:"sleeve",c:"Size L sleeve ×2"}],
      incl:"Two massagers, two size L compression sleeves, Type-C cables, manuals and boxes." }
  ],
  ids: {
    "White|1PC":        49297321427099,
    "White|2PCS":       49297321459867,
    "Wood Color|1PC":   49297321492635,
    "White S set|1PC":  49297321361563,
    "White M set|1PC":  49297321296027,
    "White L set|1PC":  49297321230491,
    "White S set1|1PC": 49297321394331,
    "White M set1|1PC": 49297321328795,
    "White L set1|1PC": 49297321263259
  },
  thumbs: ["white","wood","sleeve","anatomy","box","hero"]
};

/* ══ 2. HELPERS — every lookup is optional-safe, so a missing element
      can never stop the rest of the page building. ══ */
const $  = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];
const txt = (s, v) => { const el = $(s); if (el) el.textContent = v; };
const money = n => CONFIG.currency + n.toFixed(2);
let sel = { set: 4, qty: 1 };

/* ══ 3. EMBERS ══ */
(() => {
  const box = $("#embers");
  if (!box || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  for (let i = 0; i < 26; i++){
    const e = document.createElement("span");
    e.className = "ember-p";
    e.style.left = (55 + Math.random() * 45) + "%";
    e.style.setProperty("--dx", (Math.random() * 120 - 70) + "px");
    e.style.animationDuration = (7 + Math.random() * 9) + "s";
    e.style.animationDelay = (Math.random() * 12) + "s";
    e.style.opacity = .3 + Math.random() * .7;
    const s = 2 + Math.random() * 2.5;
    e.style.width = e.style.height = s + "px";
    box.appendChild(e);
  }
})();

/* ══ 4. VARIANT PICKER ══ */
function buildPicker(){
  const grid = $("#vgrid");
  if (grid){
    grid.innerHTML = CONFIG.sets.map((s,i) => `
      <button class="vbtn" data-i="${i}" aria-pressed="${i===sel.set}">
        ${s.tag ? `<em>${s.tag}</em>` : ""}<b>${s.name}</b><span>${s.sub}</span><u>${money(s.price)}</u>
      </button>`).join("");
    $$("#vgrid .vbtn").forEach(b => b.onclick = () => { sel.set = +b.dataset.i; sync(true); });
  }
  const th = $("#thumbs");
  if (th){
    th.innerHTML = CONFIG.thumbs.map((k,i) => `
      <button data-key="${k}" aria-current="${i===0}" aria-label="View photo ${i+1}">
        <img src="${MEDIA[k] || ""}" alt=""></button>`).join("");
    $$("#thumbs button").forEach(t => t.onclick = () => showPhoto(t.dataset.key, t));
  }
}

function renderShots(shots){
  const st = $("#galStack");
  if (!st) return;
  st.style.opacity = 0;
  setTimeout(() => {
    st.innerHTML = shots.map(s => `
      <figure>${s.x ? `<span class="gal-x">${s.x}</span>` : ""}
        <img src="${MEDIA[s.k] || ""}" alt="">
        ${s.c ? `<figcaption>${s.c}</figcaption>` : ""}
      </figure>`).join("");
    st.style.opacity = 1;
  }, 170);
}

function showPhoto(key, btn){
  renderShots([{ k:key }]);
  $$("#thumbs button").forEach(x => x.setAttribute("aria-current", x === btn));
}

function sync(swapPhoto){
  const s = CONFIG.sets[sel.set];
  const total = s.price * sel.qty;

  $$("#vgrid .vbtn").forEach(b => b.setAttribute("aria-pressed", +b.dataset.i === sel.set));
  txt("#price", money(s.price));
  txt("#btnPrice", money(total));
  txt("#vName", s.option + (s.qty === "2PCS" ? " · 2PCS" : ""));
  txt("#incl", s.incl);
  txt("#galBadge", s.option + (s.qty === "2PCS" ? " · 2PCS" : ""));
  txt("#qVal", sel.qty);
  txt("#stickyName", "Knee Massager — " + s.name);
  txt("#stickyPrice", money(s.price));

  if (s.compare && s.compare > s.price){
    txt("#was", money(s.compare));
    txt("#save", "Save " + Math.round((1 - s.price / s.compare) * 100) + "%");
  } else {
    txt("#was", ""); txt("#save", "");
  }

  if (swapPhoto){
    renderShots(s.shots);
    $$("#thumbs button").forEach(x => x.setAttribute("aria-current", false));
  }
}

if ($("#qPlus"))  $("#qPlus").onclick  = () => { sel.qty = Math.min(10, sel.qty + 1); sync(); };
if ($("#qMinus")) $("#qMinus").onclick = () => { sel.qty = Math.max(1, sel.qty - 1); sync(); };

/* ══ 5. ADD TO CART ══ */
if ($("#addBtn")) $("#addBtn").addEventListener("click", async e => {
  const btn = e.currentTarget;
  const s = CONFIG.sets[sel.set];
  const id = CONFIG.ids[s.option + "|" + s.qty];
  const label = btn.innerHTML;

  if (!id){
    btn.textContent = "Add this set's variant ID in CONFIG first";
    setTimeout(() => btn.innerHTML = label, 2800);
    return;
  }
  btn.textContent = "Adding…";
  try {
    const r = await fetch("/cart/add.js", {
      method:"POST", headers:{ "Content-Type":"application/json" },
      body: JSON.stringify({ items:[{ id, quantity: sel.qty }] })
    });
    if (!r.ok) throw new Error(await r.text());
    window.location.href = "/cart";
  } catch(err){
    console.error(err);
    btn.textContent = "That set is unavailable — try another";
    setTimeout(() => btn.innerHTML = label, 3200);
  }
});

/* ══ 6. THE CONSOLE ══ */
const deck  = $("#deck");
const HEAT  = [null, {c:45}, {c:50}, {c:55}];
const VIB   = [null, "Auto", "Low", "High"];
let cs = { on:false, heat:2, vib:1, light:1, left:900, timer:null };

function renderDeck(){
  if (!deck) return;
  deck.classList.toggle("on", cs.on);
  deck.classList.toggle("lit", cs.light > 0);
  const pwr = $("#pwr");
  if (pwr) pwr.setAttribute("aria-pressed", cs.on);
  txt("#pwrState", cs.on ? "Running" : "Standby");

  const pad = $("#padLow");
  if (pad){
    pad.style.opacity   = cs.on ? [0.4, 0.68, 1][cs.heat - 1] : 0;
    pad.style.transform = `scale(${cs.on ? [0.86, 0.95, 1.05][cs.heat - 1] : 0.7})`;
    pad.style.transformOrigin = "180px 292px";
  }
  const ring = $("#ringGlow");
  if (ring) ring.style.opacity = (cs.on && cs.light > 0) ? (cs.light === 2 ? 1 : 0.6) : 0;

  deck.style.setProperty("--vdur",   [1.5, 1.15, 0.7][cs.vib - 1] + "s");
  deck.style.setProperty("--vscale", [1.05, 1.11, 1.2][cs.vib - 1]);

  const gh = $("#gHeat");
  if (gh) gh.innerHTML = cs.on ? `${HEAT[cs.heat].c}<i>°C</i>` : "Off";
  txt("#gVib", cs.on ? VIB[cs.vib] : "Off");
  const bh = $("#bHeat"), bv = $("#bVib"), bt = $("#bTime");
  if (bh) bh.style.width = (cs.on ? cs.heat * 33.4 : 0) + "%";
  if (bv) bv.style.width = (cs.on ? cs.vib  * 33.4 : 0) + "%";
  txt("#gTime", String(Math.floor(cs.left / 60)).padStart(2,"0") + ":" +
                String(cs.left % 60).padStart(2,"0"));
  if (bt) bt.style.width = (cs.left / 900 * 100) + "%";

  $$(".temp").forEach(t => t.setAttribute("aria-pressed", +t.dataset.temp === cs.heat));
}

function powerToggle(){
  cs.on = !cs.on;
  clearInterval(cs.timer);
  cs.left = 900;
  if (cs.on){
    cs.timer = setInterval(() => {
      cs.left--;
      if (cs.left <= 0){ cs.on = false; cs.left = 900; clearInterval(cs.timer); }
      renderDeck();
    }, 1000);
  }
  renderDeck();
}
if ($("#pwr")) $("#pwr").addEventListener("click", powerToggle);

$$(".levels button").forEach(b => b.addEventListener("click", () => {
  cs[b.dataset.set] = +b.dataset.v;
  b.parentElement.querySelectorAll("button")
    .forEach(x => x.setAttribute("aria-pressed", x === b));
  if (!cs.on) powerToggle(); else renderDeck();
}));

$$(".temp").forEach(t => t.addEventListener("click", () => {
  cs.heat = +t.dataset.temp;
  $$('[data-set="heat"]').forEach(x => x.setAttribute("aria-pressed", +x.dataset.v === cs.heat));
  if (!cs.on) powerToggle(); else renderDeck();
}));

/* ══ 7. SCROLL ══ */
const io = new IntersectionObserver(en => {
  en.forEach((e,i) => {
    if (e.isIntersecting){
      setTimeout(() => e.target.classList.add("in"), i * 85);
      io.unobserve(e.target);
    }
  });
}, { threshold:0.1, rootMargin:"0px 0px -6% 0px" });
$$("[data-rise]").forEach(el => io.observe(el));

const counters = new IntersectionObserver(en => {
  en.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, to = +el.dataset.count;
    const t0 = performance.now(), dur = 1100;
    (function tick(now){
      const p = Math.min(1, (now - t0) / dur);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
    counters.unobserve(el);
  });
}, { threshold:0.5 });
$$("[data-count]").forEach(el => counters.observe(el));

let ticking = false;
addEventListener("scroll", () => {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    const h = document.documentElement;
    const pr = $("#progress");
    if (pr) pr.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + "%";
    const buyEl = $("#buy"), st = $("#sticky");
    if (buyEl && st){
      const b = buyEl.getBoundingClientRect();
      st.classList.toggle("show", h.scrollTop > 900 && !(b.top < innerHeight && b.bottom > 0));
    }
    ticking = false;
  });
}, { passive:true });

/* ══ 8. INIT ══ */
txt("#yr", new Date().getFullYear());
buildPicker();
sync(true);
renderDeck();
/* ── live price sync: page always shows what checkout charges ── */
fetch("/products/goodknees-heated-knee-massager-original.js")
  .then(r => r.ok ? r.json() : Promise.reject("HTTP " + r.status))
  .then(d => {
    const byId = {};
    (d.variants || []).forEach(v => { byId[v.id] = v.price / 100; });
    CONFIG.sets.forEach(s => {
      const p = byId[CONFIG.ids[s.option + "|" + s.qty]];
      if (typeof p === "number") s.price = p;
    });
    buildPicker();
    sync(false);
  })
  .catch(e => console.warn("GoodKnees live price sync failed:", e));